"use client";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrambleTextPlugin } from "gsap/ScrambleTextPlugin";
import { SplitText } from "gsap/SplitText";

let registered = false;

export function registerGsap() {
  if (typeof window === "undefined") return;
  if (registered) return;
  gsap.registerPlugin(ScrollTrigger, ScrambleTextPlugin, SplitText);
  registered = true;
}

export { gsap, ScrollTrigger, ScrambleTextPlugin, SplitText };
